export default __webpack_public_path__ + "static/media/Interbold.bdb91f2c.woff";